/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: () => ({
        filterButton: {
            height: '48px',
            variant: 'primary',
            marginRight: 2,
            display: 'inline-flex',
            borderRadius: '8px',
            position: 'relative',
            fontWeight: '800',
            background: 'none',
            backgroundColor: 'none',
            border: '1px solid #707070',
            color: 'textColor',
            alignItems: 'center',
            cursor: 'pointer',
            marginBottom: '0',
            textTransform: 'capitalize',
            _hover: {background: 'none', backgroundColor: 'none'}
        },
        filterHeading: {
            display: 'block',
            fontSize: '2xl',
            fontWeight: 'extrabold',
            lineHeight: '8',
            borderBottom: '1px solid',
            borderColor: '#dadada',
            pt: 4,
            pb: 4
        },
        filterItem: {
            fontSize: '16px',
            fontWeight: 'medium',
            my: 3,
            listStyleType: 'none',
            lineHeight: '24px'
        },
        showMore: {
            color: '#4a4e58',
            fontSize: '12px',
            textDecoration: 'underline',
            cursor: 'pointer',
            textUnderlineOffset: '4px',
            lineHeight: '4'
        }
    }),
    parts: ['filterButton', 'filterHeading', 'filteItem', 'showMore']
}
